module.exports = "<div class=available-quotes-list-view-outer> <div class=\"q-input-group q-marg-bottom-xl q-overflow-x-auto\"> <div class=\"q-min-width-sm q-overflow-hidden\"> <div class=\"divider-group divider-group-headers\"> <div class=row> <div class=col-xs-1> </div> <div class=col-xs-3> Estimated Pick Up </div> <div class=col-xs-3> Estimated Transit Time </div> <div class=col-xs-4> Estimated Cost </div> </div> </div> <div class=\"divider-group-body available-quote-views-entry-point\"> </div> </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/asns/ShippingTab/html/AvailableQuotesListView.html
// module id = 1223
// module chunks = 1